Ext.define('SA.view.MapToolbar', {
    extend: 'SA.view.Toolbar',

    items: [
        {
            xtype: 'combo-button',
            emptyText: 'None',
            itemId: 'attributeCombo',
            textTpl: '{name}, {year}',
            ui: 'underline',
            valueField: 'attribute'
        }, {
            xtype: 'pvt-text',
            text: 'in'
        }, {
            xtype: 'pvt-location-dropdown',
            itemId: 'locationDropdown'
        }, {
            xtype: 'pvt-text',
            text: 'by'
        }, {
            xtype: 'combo-button',
            itemId: 'unitCombo',
            textField: 'name',
            ui: 'underline',
            valueField: 'id',

            xhooks: {
                setItems(items) {
                    var getText = item => this.extractText(item),
                        didChange = !Ext.Array.equals(this.items.map(getText), items.map(getText));

                    if (didChange) {
                        this.callParent(arguments);
                    }
                }
            },

            updateText(item) {
                this.setText(this.extractText(item).replace('Auto - ', ''));
            }
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'pvt-filtering-button',
            itemId: 'filteringButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-view-actions-button',
            itemId: 'viewActionsButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-export-button',
            emitActivate: false,
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.attributeCombo = this.down('#attributeCombo');
        this.locationDropdown = this.down('#locationDropdown');
        this.unitCombo = this.down('#unitCombo');
        this.filteringButton = this.down('#filteringButton');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.filteringButton.setMenuCfg({
            xtype: 'filters-window',
            projectView: this.projectView,
            showVisibilityRadioGroup: false
        });

        this.addViewActionsButtonItems();
    },

    addViewActionsButtonItems() {
        this.viewActionsButton
            .setProjectView(this.projectView)
            .addEditItem()
            .addGroup({
                text: 'Create Data Table',
                itemId: 'createDataTableMenuItem',
                handler: () => this.fireEvent('click:createDataTable')
            })
            .addGroup({
                text: 'Export Shapefiles…',
                handler: () => Ext.widget({xtype: 'export-shapefiles-window', map: this.projectView})
            })
            .addGroup([
                {xtype: 'map-menu-hide-legend'},
                {xtype: 'map-menu-hide-labels'}
            ])
            .addGroup([
                {xtype: 'map-menu-highlight-location'},
                {xtype: 'map-menu-apply-location-mask'}
            ])
            .addDeleteItem();
    },

    disableAndClearUnitCombo() {
        this.unitCombo.disable();
        this.unitCombo.setItems([{id: null, name: 'N/A'}]);
        this.setUnitComboValue(null);
    },

    enableUnitComboWithItems(items) {
        this.unitCombo.enable();
        this.unitCombo.setItems(items);
    },

    initEvents() {
        this.callParent();

        this.attributeCombo.on('change', this.onAttributeComboChange, this);
        this.locationDropdown.on('change', this.onLocationDropdownChange, this);
        this.unitCombo.on('change', this.onUnitComboChange, this);
        this.viewActionsButton.on('beforeshow:menu', this.onBeforeShowViewActionsMenu, this);

        this.exportBtn.on('click', this.onExportButtonClick, this);
    },

    onAttributeComboChange(combo, attributeId) {
        this.fireEvent('change:attribute', attributeId);
    },

    onBeforeShowViewActionsMenu(menu) {
        var canCreateDataTable = this.projectView.hasLocation() && this.projectView.hasAttribute();

        menu.down('#createDataTableMenuItem').setEnabled(canCreateDataTable);
    },

    onExportButtonClick() {
        this.fireEvent('click:export');
    },

    onLocationDropdownChange(dropdown, location) {
        this.fireEvent('change:location', location);
    },

    onUnitComboChange(combo, unitId) {
        this.fireEvent('change:unit', unitId);
    },

    setAttributeComboItems(items) {
        this.attributeCombo.setItems([null, '-', ...items]);
    },

    setAttributeComboValue(attributeId) {
        this.attributeCombo.setValueUnevented(attributeId);
    },

    setAttributeDropdownState({selected, supported}) {
        this.attributeCombo.setItemsAndValue([null, '-', ...SA.data.AttributesCache.get(supported)], selected, {suppressEvent: true});
    },

    setFilteringButtonIndicatorVisible(visible) {
        this.filteringButton.setIndicatorVisible(visible);
    },

    setLocationDropdownItems(items) {
        this.locationDropdown.setItems(items);
    },

    setLocationDropdownState({selected, supported}) {
        this.locationDropdown.setItemsAndValue([null, '-', ...SA.data.LocationsCache.get(supported)], SA.data.LocationsCache.get(selected), {suppressEvent: true});
    },

    setLocationDropdownValue(value) {
        this.locationDropdown.setValueUnevented(value);
    },

    setModelState({attributes, filter, locations, geoUnits}) {
        this.setAttributeDropdownState(attributes);
        this.setFilteringButtonIndicatorVisible(filter !== null);
        this.setLocationDropdownState(locations);
        this.setUnitDropdownState(geoUnits);
    },

    setUnitComboValue(value) {
        this.unitCombo.setValueUnevented(value);
    },

    setUnitDropdownState({auto, isAutoSelect, selected, supportedDiscoverable}) {
        if (supportedDiscoverable.length === 0) {
            this.disableAndClearUnitCombo();

            return;
        }

        this.enableUnitComboWithItems([{id: null, name: `Auto - ${auto.name}`}, '-', ...supportedDiscoverable]);

        if (selected) {
            this.setUnitComboValue(isAutoSelect ? null : selected);
        }
    }
});